import { IComponentOptions, IController } from "angular";
import { IEntry } from "@gtmhub/configuration/workday/models";

export class WizardEntriesSelectorCtrl implements IController {
  allEntries: IEntry[];
  entries: IEntry[];
  selectedEntries: string[];
  searchPlaceholder: string;
  searchTerm: string;
  selectAllChecked: boolean;
  index: number;
  onSelected: (arg: { entries: string[] }) => void;

  $onChanges(): void {
    // we make a copy of entries sense the same object is used for all filter and we need a separate reference for each filter
    this.entries = JSON.parse(JSON.stringify(this.allEntries));

    //if first selected entry is "*" all entries are selected
    if (this.selectedEntries[0] === "*") {
      this.selectAllChecked = true;
      this.entries.forEach((entry) => {
        entry.selected = true;
      });
    } else {
      this.entries.forEach((entry) => {
        entry.selected = this.selectedEntries.includes(entry.id);
      });
    }
  }

  selectAllUpdated(selectAllChecked: boolean): void {
    if (selectAllChecked) {
      this.updateSelectedEntriesAllCheckedFlag();
    } else {
      this.entries.forEach((entry) => {
        entry.selected = false;
      });
      this.updateSelectedEntries();
    }
  }

  select(entry: IEntry): void {
    entry.selected = !entry.selected;
    // If entry is unselected we want to set select all to false
    if (!entry.selected) {
      this.selectAllChecked = false;
    }
    this.updateSelectedEntries();
  }

  searchTermUpdated(searchTerm: string): void {
    this.searchTerm = searchTerm;
  }

  private updateSelectedEntriesAllCheckedFlag(): void {
    this.entries.forEach((entry) => {
      entry.selected = true;
    });
    this.onSelected({
      entries: ["*"],
    });
  }

  private updateSelectedEntries(): void {
    const selectedEntriesIds = this.entries.filter((entry) => entry.selected).map((entry) => entry.id);
    this.onSelected({
      entries: selectedEntriesIds,
    });
  }
}

export const WizardEntriesSelectorComponent: IComponentOptions = {
  bindings: {
    allEntries: "<",
    selectedEntries: "<",
    index: "<",
    searchPlaceholder: "<",
    onSelected: "&",
  },

  controller: WizardEntriesSelectorCtrl,
  templateUrl: require("./entries-selector.jade"),
  controllerAs: "$ctrl",
};
